import { render, staticRenderFns } from "./detailAccommodation.vue?vue&type=template&id=3ee51c70&scoped=true"
import script from "./detailAccommodation.vue?vue&type=script&lang=js"
export * from "./detailAccommodation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee51c70",
  null
  
)

export default component.exports